// 用户服务管理
import axios from '@/libs/api.request'

// 获取登录用户
export const getCurrentUser = (data) => {
  return axios.request({
    data: data,
    url: '/api/user/getCurrentHrUserInfo',
    method: 'post'
  })
}
